import { PrimaryButton } from '@systemeio/ui'
import { useStore } from 'modules/stores/store/hooks/use-store'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'
import { FC } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { StoreTabEnum } from '../enum/store-tab-enum'
import { SettingsIcon } from '@systemeio/ui/icons'

const StoreEditButton: FC = () => {
  const { storeId } = useStoreQuery()
  const { data: store } = useStore(storeId)
  const { onChangeTab } = useStoreQuery()
  const { t } = useLocoTranslation()

  return (
    <>
      <PrimaryButton disabled={!store} onClick={() => onChangeTab(StoreTabEnum.storeSettings)}>
        <SettingsIcon className={'fill-background-secondary'} />
        <span className="hidden sm:inline">{t('global.settings')}</span>
      </PrimaryButton>
    </>
  )
}

export default StoreEditButton
